import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const TrimsBundleReceiptEntry = () => {
  return (
    <SectionBundleReceiptEntry
      sectionName="Trims"
      sectionDisplayName="Trims Section"
      backRoute="/sections/trims"
    />
  );
};

export default TrimsBundleReceiptEntry;
